<script setup>
  const props = defineProps({
      code: Number,
      name: String,
      email: String,
      password: String,
      role: String
  })
</script>
<template>
  <form>
    <div class="row">
      <div class="col-lg-8 col-md-8">
        <card>
          <div slot="header">
            <h4 class="title">Perfil del usuario</h4>
          </div>
          <div>
            <input type="hidden" v-model="user.code" />
            <div class="row">
              <div class="col-md-6">
                <fg-input type="text" label="Nombre" placeholder="Nombre" v-model="user.name">
                </fg-input>
              </div>
              <div class="col-md-6">
                <fg-input
                  type="email"
                  label="Correo"
                  placeholder="Email"
                  v-model="user.email"
                >
                </fg-input>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <fg-input label="Clave"
                          type="password"
                          placeholder="Clave"
                          v-model="user.password">
                </fg-input>
              </div>
              <div class="col-md-6 form-group has-label">
                <label>Rol</label>
                <el-select class="select-primary"
                            size="large"
                            placeholder="Rol"
                            v-model="user.role">
                  <el-option v-for="option in selects.roles"
                              :value="option.value"
                              :label="option.label"
                              :key="option.label">
                  </el-option>
                </el-select>
              </div>
            </div>

            <div>
              <button
                type="submit"
                class="btn btn-primary btn-fill btn-wd"
                @click.prevent="saveProfile"
              >
                Guardar usuario
              </button>
              <router-link
                to="/users/manage"
                custom
                v-slot="{ navigate }"
              >
                <button
                  type="button"
                  class="btn btn-default btn-fill btn-wd pull-right"
                  @click="navigate"
                  role="link"
                >
                  Cancelar
                </button>
              </router-link>
            </div>
            <div class="clearfix"></div>
          </div>
        </card>
      </div>

      <div class="col-lg-4 col-md-5">
        <card class="card-user">
          <div slot="image">
            <img src="static/img/books-user-bg.jpg" alt="background" />
          </div>
          <div>
            <div class="author">
              <img class="avatar border-gray" :src="userAvatar" alt="avatar">
              <h4 class="title">{{ user.name }}
                <br>
                <p class="category text-muted">{{ user.role }}</p>
              </h4>
            </div>
            <p class="description text-center">
              <button
                type="submit"
                class="btn btn-primary btn-fill btn-wd"
                @click.prevent="updateProfilePicture"
              >
                Cambiar foto
              </button>
            </p>
          </div>
        </card>
      </div>
    </div>
  </form>
</template>
<script>
import { Input, Tag, Select, Option } from 'element-ui'
import Swal from 'sweetalert2'
import axios from "axios";

export default {
  components: {
    [Input.name]: Input,
    [Tag.name]: Tag,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data() {
    return {
      user: JSON.parse(localStorage.getItem('user')),
      userAvatar: 'static/img/faces/' + JSON.parse(localStorage.getItem('user')).avatar,
      selects: {
        roles: [
          {value: 'Administrador', label: 'Administrador(a)'},
          {value: 'Autor', label: 'Autor(a)'},
          {value: 'Colaborador', label: 'Colaborador(a)'}
        ],
      },
    };
  },
  methods: {
    saveProfile() {
      if (this.user.code !== 0) {
        this.updateUser(this.user);
      } else {
        this.createUser(this.user);
      }
    },
    createUser (row) {
      axios.post(this.$systemVariables.apiUrl + 'users', row, {
        'headers': { 'Authorization': JSON.parse(localStorage.getItem('jwt')).value }
      })
      .then((response) => {
        Swal.fire({
          title: this.$systemVariables.recordCreatedSuccessfully,
          html: "",
          icon: "success"
        })
        .then(function () {
          window.location.href = '#/users/manage';
        });
      })
      .catch((error) => {
        // console.error('Error al crear el usuario:', error);
      });
    },
    updateUser (row) {
      axios.put(this.$systemVariables.apiUrl + 'users/' + row.code, row, {
        'headers': { 'Authorization': JSON.parse(localStorage.getItem('jwt')).value }
      })
      .then((response) => {
        Swal.fire({
          title: this.$systemVariables.recordUpdatedSuccessfully,
          html: "",
          icon: "success"
        })
        .then(function () {
          window.location.href = '#/users/manage';
        });
      })
      .catch((error) => {
        // console.error('Error al guardar el usuario:', error);
      });
    }
  },
};
</script>
<style>
  .el-input__inner {
    cursor: pointer !important;
  }
</style>
